// import axios from "axios";
import * as d3 from "d3";
import {contextMenu, createTooltip, generateDownloadData, inrFormatterV2} from '../functions'

export default function (chart, divId,vizName, resData,filterParam,checkbox) {
    // var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName
    // console.log("Chart vizName called:", vizName, divId, url)

    // load the data
    // axios.post(url, filterParam).then(res => {
        let data = resData
        console.log("data is:", data)

        var types = d3.nest()
            .key(function (d) {
                return d.dim1_name
            })
            .entries(data);

        console.log("types", types)

        //  var width = 600, height = 300;
        var svg = d3.select(divId).selectAll("svg").remove();
        svg = d3.select(divId)
            .selectAll('svg')
            .data(types)
            .enter()
            .append('svg')
            .attr('width', chart.width)
            .attr('height', chart.height)
        //   .call(responsivefy)
        // .attr('transform', 'translate(' + chart.margin.left + ',' + chart.margin.top + ')')

        var
            radius = 100;
        console.log("radius", radius)

        // var div = d3.select(divId).append("div").attr("class", "toolTip");

        const tooltip1 = createTooltip(divId);

        //    var div2 = d3.select(divId).append("div")

        // var g = svg.append("g")
        //     .attr("transform", "translate(" + chart.width / 2 + "," + chart.height / 2.2 + ")");


        var color = d3.scaleOrdinal().range(chart.vizSpecific7.colorScheme);


        var types2 = d3.nest()
            .key(function (d) {
                return d.dim1_name
            })
            .rollup(function (v) {
                return d3.sum(v, function (d) {
                    return d.metric1
                })
            })
            .entries(data);


        var pie = d3.pie()
            .value(function (d) {
                return d.metric1;
            }).sort(null);

        var rscale = d3.scaleSqrt()
            .domain([d3.min(types2, function (d) {
                return d.value
            }),
                d3.max(types2, function (d) {
                    return d.value
                })])
            .range([5, 40])
        console.log(rscale)

        //   console.log("data2", data2)
        var tots = d3.sum(data, function (d) {
            return d.metric1;
        });

        //  var total=d3.nest(types.values,d=>d.dim1_name)

        //  console.log("total",total)

        console.log("tots", tots)

        console.log("datapie", data)

        var path = d3.arc()
            .outerRadius(radius - 5)
            .innerRadius(40);

        if (checkbox == true) {

            var g = svg.append("g")
                .attr("transform", "translate(" + chart.width / 2 + "," + chart.height / 2 + ")");

            var elemEnter2 = svg
                .append("g")
                .attr("transform", "translate(150, 50)"); // prevent svg crops first circle
            //   .attr("transform", "translate("0,100);
            console.log(elemEnter2)
            var circles2 = elemEnter2
                .append("circle")
                .data(types2)
                .attr("r", function (d) {
                    return rscale(d.value)
                })
                // .attr("r", 20)
                //function(d){ return rscale(d.values.metric1)})
                .style("fill", "#838996")
                .on('mouseover', function(d) {
                    tooltip1.onMouseOver(d, this, function(d) {
                       return d.key + '<br>' + inrFormatterV2(d.value,chart.data.menuId)
                    });  // Pass the event for positioning
                })
                .on('mousemove', function(event) {
                    tooltip1.onMouseMove(event);  // Use event for updating position
                })
                .on('mouseleave', function() {
                    tooltip1.onMouseLeave();  // Hide tooltip on mouse leave
                })
                .on('contextmenu', function(d) {

                    // Prepare clickedData with both axes' info
                    const clickedData = {
                        [chart.insightNavigator.realDataFieldNames.x1RealDataFieldName]: [d.dim1_name]               // e.g., "metric1"
                    };
                    console.log("clickedData",clickedData);
                    // Generate the menu with current config and filters
                    const menuItems = generateDownloadData(chart.insightNavigator.navList, filterParam);

                    // Show the context menu
                    contextMenu(menuItems).call(this, clickedData);

                    // Prevent default context menu
                    d3.event.preventDefault();
                });
            console.log(circles2)
            /*circles2.append("text")
                .attr("dx",  20)
                .text(function(d){
                    return d.key + ': ' + numberFormat(d.value) + ' (' +  Math.round((d.value / tots) * 100) +'%)'
                })*/


            var arc = g.selectAll(".arc")
                .data(function (d) {
                    console.log("Pies", pie(d.values));
                    return pie(d.values)
                })
                .enter().append("g")
                .attr("class", "arc");


            arc.append("path")
                .attr("d", path)
                .attr("fill", function (d) {
                    return color(d.data.dim2_name);
                })
                .on('mouseover', function(d) {
                    tooltip1.onMouseOver(d, this, function(d) {
                        return d.data.dim2_name + '<br>' +
                            Math.round((d.endAngle - d.startAngle) / (2 * Math.PI) * 100) + '%' + '(' + inrFormatterV2(d.data.metric1,chart.data.menuId) + ' out of ' + inrFormatterV2(types2.filter(f => f.key == d.data.dim1_name).map(f => f.value)[0],chart.data.menuId) + ')'
                    });  // Pass the event for positioning
                })
                .on('mousemove', function(event) {
                    tooltip1.onMouseMove(event);  // Use event for updating position
                })
                .on('mouseleave', function() {
                    tooltip1.onMouseLeave();  // Hide tooltip on mouse leave
                })
                .on('contextmenu', function(d) {

                    // Prepare clickedData with both axes' info
                    const clickedData = {
                        [chart.insightNavigator.realDataFieldNames.y1RealDataFieldName]: [d.data.dim2_name]               // e.g., "metric1"
                    };
                    console.log("clickedData",clickedData);
                    // Generate the menu with current config and filters
                    const menuItems = generateDownloadData(chart.chart.insightNavigator.navList, filterParam);

                    // Show the context menu
                    contextMenu(menuItems).call(this, clickedData);

                    // Prevent default context menu
                    d3.event.preventDefault();
                });


            var title = svg.append("g")
                .data(types2)
                .append("text")
                .attr("x", chart.width / 2)
                .attr("y", 120)
                .style('text-anchor', 'middle')
                .attr("dominant-baseline", "central")
                .attr('font-weight', 'bold')
                .text(function (d) {
                    return d.key + ': ' + inrFormatterV2(d.value,chart.data.menuId) + ' (' + Math.round((d.value / tots) * 100) + '%)'
                })

            console.log(title)

            var legend = svg.append('g')
                .attr("class", "legend")
                .selectAll("g")
                .data(function (d) {
                    return pie(d.values)
                }, function (d) {
                    return d.data.dim2_name;
                })//setting the data as we know there are only two set of data[programmar/tester] as per the nest function you have written
                .enter().append("g")
                .attr("transform", function (d, i) {
                    return "translate(0," + (i * 20 + 60) + ")";
                });

            legend.append("rect")
                .attr('x', chart.width / 4)
                .attr('y', chart.height / 1.54)
                .attr("width", 18)
                .attr("height", 18)
                .style("fill", function (d) {
                    return color(d.data.dim2_name);
                });

            legend.append("text")
                .attr("x", chart.width / 3)
                .attr("y", chart.height / 1.5)
                .attr("dy", ".35em")
                .text(function (d) {
                    return Math.round((d.endAngle - d.startAngle) / (2 * Math.PI) * 100) + '%' + ' ' + d.data.dim2_name;
                });
        } else {

            g = svg.append("g")
                .attr("transform", "translate(" + chart.width / 2 + "," + chart.height / 2.7 + ")");

            elemEnter2 = svg
                .append("g")
                .attr("transform", "translate(150, 50)"); // prevent svg crops first circle
            //   .attr("transform", "translate("0,100);
            console.log(elemEnter2)

            // Initialize tooltip
            const tooltip = createTooltip(divId);

            arc = g.selectAll(".arc")
                .data(function (d) {
                    console.log("Pies", pie(d.values));
                    return pie(d.values)
                })
                .enter().append("g")
                .attr("class", "arc");


            arc.append("path")
                .attr("d", path)
                .attr("fill", function (d) {
                    return color(d.data.dim2_name);
                })
                // .on("mousemove", function (d) {
                //     console.log(d3.event, d)
                //     div.transition()
                //         .duration(200)
                //         .style("opacity", .9);
                //     div.html(d.data.dim2_name + '<br>' +
                //         Math.round((d.endAngle - d.startAngle) / (2 * Math.PI) * 100) + '%' + '(' + numberFormat(d.data.metric1) + ' out of ' + numberFormat(types2.filter(f => f.key == d.data.dim1_name).map(f => f.value)[0]) + ')')
                //         .style("display", "block")
                //         .style("left", (d3.event.pageX) + "px")
                //         .style("top", (d3.event.pageY) + "px");
                // })
                // .on("mouseout", function () {
                //     div.transition()
                //         .style("display", "none")
                //         .style("opacity", 0)
                // });
                .on('mouseover', function(d) {
                    tooltip.onMouseOver(d, this, data => data.data.dim2_name + '<br>' +
                        Math.round((data.endAngle - data.startAngle) / (2 * Math.PI) * 100) + '%' + '(' + inrFormatterV2(data.data.metric1,chart.data.menuId) + ' out of ' + inrFormatterV2(types2.filter(f => f.key == data.data.dim1_name).map(f => f.value)[0],chart.data.menuId) + ')')  // Pass tooltip content
                })
                .on('mousemove', tooltip.onMouseMove)
                .on('mouseleave', function() {
                    tooltip.onMouseLeave(this);
                })
                .on('contextmenu', function(d) {

                    // Prepare clickedData with both axes' info
                    const clickedData = {
                        [chart.insightNavigator.realDataFieldNames.y1RealDataFieldName]: [d.data.dim2_name]               // e.g., "metric1"
                    };
                    console.log("clickedData",clickedData);
                    // Generate the menu with current config and filters
                    const menuItems = generateDownloadData(chart.insightNavigator.navList, filterParam);

                    // Show the context menu
                    contextMenu(menuItems).call(this, clickedData);

                    // Prevent default context menu
                    d3.event.preventDefault();
                });



            title = svg.append("g")
                .data(types2)
                .append("text")
                .attr("x", chart.width / 2)
                .attr("y", 40)
                .style('text-anchor', 'middle')
                .attr("dominant-baseline", "central")
                .attr('font-weight', 'bold')
                .text(function (d) {
                    if (chart.vizSpecific5 === '%') {
                        return d.key + ': ' + inrFormatterV2(d.value,chart.data.menuId) + ' (' + Math.round((d.value / tots) * 100) + '%)'
                    } else {
                        return d.key + ': ' + inrFormatterV2(d.value,chart.data.menuId)
                    }
                })

            console.log(title)

            legend = svg.append('g')
                .attr("class", "legend")
                .selectAll("g")
                .data(function (d) {
                    return pie(d.values)
                }, function (d) {
                    return d.data.dim2_name;
                })//setting the data as we know there are only two set of data[programmar/tester] as per the nest function you have written
                .enter().append("g")
                .attr("transform", function (d, i) {
                    return "translate(0," + (i * 20 + 60) + ")";
                });

            legend.append("rect")
                .attr('x', chart.width / 4)
                .attr('y', chart.height / 1.86)
                .attr("width", 18)
                .attr("height", 18)
                .style("fill", function (d) {
                    return color(d.data.dim2_name);
                });

            legend.append("text")
                .attr("x", chart.width / 3)
                .attr("y", chart.height / 1.8)
                .attr("dy", ".35em")
                .text(function (d) {
                    return Math.round((d.endAngle - d.startAngle) / (2 * Math.PI) * 100) + '%' + ' ' + d.data.dim2_name;
                });
        }

    // })
}
